import BrokerApplicationDashboard from './BrokerApplicationDashboard'

export default BrokerApplicationDashboard
